import { lazy } from 'react';
import Loadable from '../components/others/load/Loadable';
import AuthLayout from '../layouts/AuthLayout';
import MarketWrapper from '../plugins/Market/pages/MarketWrapper';
import MobileWrapper from '../plugins/Mobile/pages/MobileWrapper';
import { redgerlabRoutes } from '../plugins/loadRedgerlab';


const DashboardPage = Loadable(()=>import('../pages/dashboard/DashboardPage'));
const UsersPage = Loadable(()=>import('../pages/users/UsersPage'));
const IndexPage = Loadable(()=>import('../pages/index/IndexPage'));
const ProfilePage = Loadable(()=>import('../pages/profile/ProfilePage'));
const SettingsPage = Loadable(()=>import('../pages/settings/SettingsPage'));
const SitePagesPage = Loadable(()=>import('../pages/sitePages/SitePagesPage'));
const SiteBlogPage = Loadable(()=>import('../pages/siteBlog/SiteBlogPage'));
const RedirectsPage = Loadable(()=>import('../pages/redirects/RedirectsPage'));
const PageBlock = Loadable(()=>import('../pages/sitePageBlock/PageBlock'));
const PostContent = Loadable(()=>import('../pages/postContent/PostContentPage'));

const MarketCategory = Loadable(()=>import('../plugins/Market/pages/MarketCategoryPage'));
const MarketCategories = Loadable(()=>import('../plugins/Market/pages/MarketCategoriesPage'));
const MarketProducts = Loadable(()=>import('../plugins/Market/pages/MarketProductsPage'));
const MarketProduct = Loadable(()=>import('../plugins/Market/pages/MarketProductPage'));
const MarketOrders = Loadable(()=>import('../plugins/Market/pages/MarketOrdersPage'));
const MarketReviewsPage = Loadable(()=>import('../plugins/Market/pages/MarketReviewsPage'));
const MarketPromoPage = Loadable(()=>import('../plugins/Market/pages/MarketPromoPage'));
const MobileNotificationsPage = Loadable(()=>import('../plugins/Mobile/pages/MobileNotificationsPage'));

   
const mainChildren = [
        {
            path: '/',
            element: <IndexPage/>
        },
        {
            path: '/users',
            element: <UsersPage/>
        },
        {
            path: '/redirects',
            element: <RedirectsPage/>
        }, 
        {
            path: '/dashboard',
            element: <DashboardPage/>
        },
        {
            path: '/settings',
            element: <SettingsPage/>
        },
        {
            path: '/pages',
            element: <SitePagesPage/>
        },
        {
            path: '/pages/block/:blockId',
            element: <PageBlock/>
        },
        {
            path: '/blog',
            element: <SiteBlogPage/>
        },
        {
            path: '/blog/post/:postId',
            element: <PostContent/>
        },
        {
            path: '/profile',
            element: <ProfilePage/>
        },

        {
     

        path: '/market',
        element : <MarketWrapper/>,
        children:[
            // MARKET 
            {
                path: 'categories',
                element: <MarketCategories/>
            },
            {
                path: 'category/:categoryId',
                element: <MarketCategory/>
            },
            {
                path: 'products',
                element: <MarketProducts/>
            },
            {
                path: 'products/category/:categoryId',
                element: <MarketProducts/>
            },            
            {
                path: 'product/:productId',
                element: <MarketProduct/>
            },

            {
                path: 'orders',
                element: <MarketOrders/>
            },

            {
                path: 'reviews',
                element: <MarketReviewsPage/>
            },
           {
                path: 'reviews/:productId',
                element: <MarketReviewsPage/>
            },
            {
                path: 'promo',
                element: <MarketPromoPage/>
            }
        ]

        },
        {
            path: '/mobile',
            element: <MobileWrapper/>,
            children: [
                {
                    path: 'notifications',
                    element: <MobileNotificationsPage/>
                }
            ]
        }

    ];

if (redgerlabRoutes) {
    mainChildren.push(redgerlabRoutes);
}

const MainRoutes = {
    path: '/',
    element: <AuthLayout/>,  
    children: mainChildren
}

export default MainRoutes;